export default __webpack_public_path__ + "static/Buro_de_Entidades_Financieras_Capital_Funding_Lab-6df7aedcbc2a1ddd0f82d1ba48037202.pdf";